// extracted by mini-css-extract-plugin
module.exports = {"a11yOnly":"global__a11yOnly--3n7m7","a11yOnlyFocusable":"global__a11yOnlyFocusable--aYOy3"};